export const ts = {
  EMPLOYEE_MY_PASS: {
    description: 'new grid title',
    primaryValue: 'My Pass',
    stringKey: 'EMPLOYEE_MY_PASS',
  },
  GRID_HEADER_ACTIONS: {
    description: 'grid header actions',
    primaryValue: 'Actions',
    stringKey: 'GRID_HEADER_ACTIONS',
  },
  GRID_HEADER_NAME: {
    description: 'grid header name',
    primaryValue: 'Name',
    stringKey: 'GRID_HEADER_NAME',
  },
};
